<template>
  <common-page
    ref="commonPage"
    :bg-path="bgPath"
    :web-path="webPath"
    :columns="columns"
    :table-options="tableOptions"
    :search-items="searchItems"
    :form-items="formItems"
  />
</template>
<script>
export default {
  data() {
    return {
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'pharmacy/decocting/decoctingstlmt/agentstlmt',
      // Web路径
      webPath: 'pharmacy/decocting/decoctingstlmt/agentstlmt',
      tableOptions: ['details', 'filter'],
      // ===== ===== ===== ===== 页面配置 ===== ===== ===== =====
      // 搜索内容
      searchItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "storeCode",
              span: 6,
              name: "门店编码",
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "storeName",
              name: "门店名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "pharmacyCode",
              span: 6,
              name: "药房编码",
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "pharmacyName",
              name: "药房名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "agentPrescriptionCode",
              span: 6,
              name: "代售处方编码",
              type: "text",
              config: {
                edit: false
              }
            },
            {
              code: "stlmtTime",
              name: "结算时间",
              type: "datetime",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "stateSign",
              name: "状态标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "待支付" },
                  { key: "2", value: "已支付" },
                  { key: "3", value: "关闭" }
                ]
              }
            },
            {
              code: "payTypeSign",
              name: "支付方式标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "支付宝" },
                  { key: "2", value: "微信" },
                  { key: "3", value: "线下" }
                ]
              }
            },
            {
              code: "paySign",
              name: "支付结果标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "0", value: "未支付" },
                  { key: "1", value: "支付" }
                ]
              }
            },
            {
              code: "payNotifySign",
              name: "支付通知标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                defaultValue: '0',
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "0", value: "未支付" },
                  { key: "1", value: "支付" }
                ]
              }
            }
          ]
        }
      ],
      // 列表内容
      columns: [
        {
          code: "code",
          name: "编码",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "storeCode",
          span: 6,
          name: "门店编码",
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "storeName",
          name: "门店名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "pharmacyCode",
          span: 6,
          name: "药房编码",
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "pharmacyName",
          name: "药房名称",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: true
          }
        },
        {
          code: "agentPrescriptionCode",
          span: 6,
          name: "代售处方编码",
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "stlmtTime",
          name: "结算时间",
          type: "datetime",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "ordAmount",
          name: "订单金额",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "stageNumber",
          name: "分期数",
          type: "number",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "stateSign",
          name: "状态标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            defaultValue: '1',
            keyField: "key",
            valueField: "value",
            options: [
              { key: "1", value: "待支付" },
              { key: "2", value: "已支付" },
              { key: "3", value: "关闭" }
            ]
          }
        },
        {
          code: "payTypeSign",
          name: "支付方式标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            defaultValue: '1',
            keyField: "key",
            valueField: "value",
            options: [
              { key: "1", value: "支付宝" },
              { key: "2", value: "微信" },
              { key: "3", value: "线下" }
            ]
          }
        },
        {
          code: "paySign",
          name: "支付结果标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            defaultValue: '0',
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未支付" },
              { key: "1", value: "支付" }
            ]
          }
        },
        {
          code: "payNotifySign",
          name: "支付通知标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未支付" },
              { key: "1", value: "支付" }
            ]
          }
        },
        {
          code: "ordParam1",
          name: "订单参数1",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "ordParam2",
          name: "订单参数2",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "ordParam3",
          name: "订单参数3",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "ordParam4",
          name: "订单参数4",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "ordParam5",
          name: "订单参数5",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        },
        {
          code: "reDate",
          name: "返回值",
          type: "text",
          span: 6,
          config: {
            edit: false,
            disabled: false
          }
        }
      ],
      // 增加/修改/详情 表单
      formItems: [
        {
          rowIndex: 1,
          items: [
            {
              code: "code",
              name: "编码",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "storeCode",
              span: 6,
              name: "门店编码",
              type: "popup",
              config: {
                url: "base/user/user/store",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("storeName", row.name)
                  this.$refs.commonPage.updateFormData("storeId", row.id)
                }
              }
            },
            {
              code: "storeName",
              name: "门店名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "pharmacyCode",
              span: 6,
              name: "药房编码",
              type: "popup",
              config: {
                url: "base/user/user/pharmacy",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("pharmacyName", row.name)
                  this.$refs.commonPage.updateFormData("pharmacyId", row.id)
                }
              }
            },
            {
              code: "pharmacyName",
              name: "药房名称",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: true
              }
            },
            {
              code: "agentPrescriptionCode",
              span: 6,
              name: "代售处方编码",
              type: "popup",
              config: {
                url: "pharmacy/storage/agentpre/agentprescription",
                filedList: [
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ],
                searcher: {},
                defaultValue: "",
                minLength: 0,
                maxLength: 20,
                disabled: false,
                require: true
              },
              handleEvent: {
                onPopupClick: (code, row) => {
                  this.$refs.commonPage.updateFormData(code, row.code)
                  this.$refs.commonPage.updateFormData("agentPrescriptionName", row.name)
                  this.$refs.commonPage.updateFormData("agentPrescriptionId", row.id)
                }
              }
            },
            {
              code: "stlmtTime",
              name: "结算时间",
              type: "datetime",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "ordAmount",
              name: "订单金额",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "stageNumber",
              name: "分期数",
              type: "number",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "stateSign",
              name: "状态标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                defaultValue: '1',
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "待支付" },
                  { key: "2", value: "已支付" },
                  { key: "3", value: "关闭" }
                ]
              }
            },
            {
              code: "payTypeSign",
              name: "支付方式标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                defaultValue: '1',
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "1", value: "支付宝" },
                  { key: "2", value: "微信" },
                  { key: "3", value: "线下" }
                ]
              }
            },
            {
              code: "paySign",
              name: "支付结果标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                defaultValue: '0',
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "0", value: "未支付" },
                  { key: "1", value: "支付" }
                ]
              }
            },
            {
              code: "payNotifySign",
              name: "支付通知标识",
              type: "select",
              span: 6,
              config: {
                edit: false,
                defaultValue: '0',
                keyField: "key",
                valueField: "value",
                options: [
                  { key: "0", value: "未支付" },
                  { key: "1", value: "支付" }
                ]
              }
            },
            {
              code: "ordParam1",
              name: "订单参数1",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "ordParam2",
              name: "订单参数2",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "ordParam3",
              name: "订单参数3",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "ordParam4",
              name: "订单参数4",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "ordParam5",
              name: "订单参数5",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            },
            {
              code: "reDate",
              name: "返回值",
              type: "text",
              span: 6,
              config: {
                edit: false,
                disabled: false
              }
            }
          ]
        }
      ]
    }
  }
}
</script>
